import { DocumentationVersionChangesOutDto } from './entity';
import { IDocumentationUploader } from './uploadDocumentation';

interface Changes { description: string }

export type UploadDocumentationChange = (
    uploader: IDocumentationUploader,
    url: string,
    data: Changes
  ) => Promise<boolean>;

export type UploadDocumentationVersionChange = (
    uploader: IDocumentationUploader,
    url: string,
    data: DocumentationVersionChangesOutDto
  ) => Promise<boolean>;

export const uploadDocumentationChange: UploadDocumentationChange =
  async function _uploadDocumentationChange(
    uploader: IDocumentationUploader,
    url: string,
    data: Changes
  ): Promise<boolean> {
    try {
      await uploader.PUT(url, data);
      return true;
    } catch (e) {
      return false;
    }
  };

export const uploadDocumentationVersionChange: UploadDocumentationVersionChange =
  async function _uploadDocumentationVersionChange(
    uploader: IDocumentationUploader,
    url: string,
    data: DocumentationVersionChangesOutDto
  ): Promise<boolean> {
    try {
      await uploader.PUT(url, data);
      return true;
    } catch (e) {
      return false;
    }
  };
